import {Component, HostBinding} from '@angular/core';

const componentBaseName = 'section-content';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-section-content',
  templateUrl: './section-content.component.html',
})
export class SectionContentComponent {
  @HostBinding('class') classNames = defaultClassNames;
  constructor() { }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-base/components/section-content/section-content.component.ts